module.exports = __webpack_public_path__ + "img/dots_mtb1.ad413c03.png";